module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2OSIgaGVpZ2h0PSI2OSIgZmlsbD0ibm9uZSIgeG1sbnM6dj0iaHR0cHM6Ly92ZWN0YS5pby9uYW5vIj48cGF0aCBkPSJNMzQuNSAxNEw1MyAyNC41djIxTDM0LjUgNTYgMTYgNDUuNXYtMjFMMzQuNSAxNHptMCAyNi43MjdjMS41NDkgMCAzLjAzNS0uNjAzIDQuMTMxLTEuNjc4YTUuNjcgNS42NyAwIDAgMCAwLTguMWMtMS4wOTYtMS4wNzQtMi41ODItMS42NzctNC4xMzEtMS42NzdzLTMuMDM1LjYwMy00LjEzMSAxLjY3N2E1LjY3IDUuNjcgMCAwIDAgMCA4LjFjMS4wOTYgMS4wNzQgMi41ODIgMS42NzggNC4xMzEgMS42NzhoMHoiIGZpbGw9IiM3MEExNEYiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./static/img/icon/setting.svg
// module id = fRIR
// module chunks = 215